import { AddIcon } from "@chakra-ui/icons";
import { IconButton, useToast } from "@chakra-ui/react";
import { InsertMidSpotInput } from "~/generated/graphql.types";
import { useInsertMidSpotMutation } from "./index.generated";
import { useEffect } from "react";

export const InsertSpotButton = ({ input }: { input: InsertMidSpotInput }) => {
  const [insertMidSpotRes, insertMidSpot] = useInsertMidSpotMutation();
  const toast = useToast();

  useEffect(() => {
    if (!insertMidSpotRes.data) return;
    if (
      insertMidSpotRes.data?.insertMidSpot.__typename === "InsertSpotSuccess"
    ) {
      toast({
        title: "スポットを追加しました",
        status: "success",
        duration: 3000,
        isClosable: true,
      });
      return;
    }
    if (
      insertMidSpotRes.data?.insertMidSpot.__typename === "InsertSpotFailure"
    ) {
      console.error(insertMidSpotRes);
      toast({
        title: "スポットの追加に失敗しました",
        description: insertMidSpotRes.data.insertMidSpot.message,
        status: "error",
        duration: 3000,
        isClosable: true,
      });
      return;
    }
  }, [insertMidSpotRes.data, toast]);

  return (
    <IconButton
      rounded="full"
      aria-label="ここにスポットを追加"
      size="xs"
      variant="outline"
      textColor="white"
      icon={<AddIcon />}
      onClick={() => {
        insertMidSpot(
          { input },
          { additionalTypenames: ["Course", "RoutingInfomationPayload"] }
        );
      }}
      data-testid={"insert-spot-button"}
    />
  );
};
